import { connect } from 'react-redux'
import {
  getTowns,
  getTownsOptionBySuburbs,
} from '../../../../store/dashboard/duck'
import { getFilterParams } from '../../../../store/strategistV2/dashboard/actions'
import {
  clearJunglerUserPhase,
  addJunglerUser,
} from '../../../../store/strategistV2/jungleruser/actions'

import AddUserComponent from './component'

const AddUserContainer = connect(
  // Map state to props
  (state) => ({
    filterParams: state.strategistV2.dashboard.filterParams,
    townData: state.dashboard.townData,
    createJunglerUserPhase: state.strategistV2.junglerUser.createJunglerUserPhase,
    junglerUserPhaseData: state.strategistV2.junglerUser.junglerUserPhaseData
  }),
  // Map actions to dispatch and props
  {
    getTowns,
    getTownsOptionBySuburbs,
    addJunglerUser,
    clearJunglerUserPhase,
    getFilterParams,
  }
)(AddUserComponent)

export default AddUserContainer
